import { render, staticRenderFns } from "./RedeemAction.vue?vue&type=template&id=e2a4628e&scoped=true&"
import script from "./RedeemAction.vue?vue&type=script&lang=js&"
export * from "./RedeemAction.vue?vue&type=script&lang=js&"
import style0 from "./RedeemAction.vue?vue&type=style&index=0&id=e2a4628e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a4628e",
  null
  
)

export default component.exports